import { all, fork } from 'redux-saga/effects'

import authSagas from '@/containers/Login/AuthSagas'
import pageConfigurationSagas from '@/store/PageConfiguration/PageConfigurationSagas'
import usersManagementSagas from '@/containers/UsersManagement/UsersManagementSagas'
import servicesStatusSagas from '../containers/ServicesStatus/ServicesStatusSagas'
import carbonOffsetsSagas from '../containers/CarbonOffsetManagement/CarbonOffsetsSagas'
import officesManagementSagas from '../containers/OfficesManagement/OfficesManagementSagas'
import teamsManagementSagas from '../containers/TeamsManagement/TeamsManagementSagas'
import suppliersManagementSagas from '../containers/SuppliersManagement/SuppliersManagementSagas'
import italyFiscalCodesManagementSagas from '@/containers/ItalyFiscalCodesManagement/italyFiscalCodesManagementSagas'
import websalesUsersManagementSagas from '../containers/WebsalesUsersManagement/WebsalesUsersManagementSagas'
import assistanceSagas from '../containers/AssistanceProductsManagement/AssistanceSagas'
import monConseillerPersoSagas from '../containers/MonConseillerPersoProductsManagement/MonConseillerPersoSagas'
import subscriptionFormV2Sagas from '../containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormV2Sagas'
import clientCallbacksSagas from '@/containers/ClientCallbacksPage/ClientCallbacksSagas'
import breakManagementSagas from '@/containers/BreakManagementPage/breakManagementSagas'
import additionalProductsToolsSagas from '../containers/AdditionalSalesManagement/additionalProductsToolsSagas'
import searchContactsSagas from '../containers/ContactSearchPage/searchContactsSagas'
import contactsToolsSagas from '@/containers/DevToolsNew/Contacts/contactsSagas'
import podUpdaterSagas from '@/containers/DevToolsNew/PodUpdater/podUpdaterSagas'
import commandsSagas from '@/containers/DevToolsNew/Commands/commandsSagas'
import communicationBoardSagas from '@/containers/DevToolsNew/CommunicationBoard/communicationBoardSagas'
import pollResultsSagas from '@/containers/DevToolsNew/CommunicationBoard/PollResults/pollResultsSagas'
import boardPollsSagas from '@/containers/SubscriptionFormPageNew/Components/CommunicationBoard/BoardPoll/boardPollsSagas'
import cacheSagas from '@/containers/DevToolsNew/Cache/cacheSagas'
import betaFeaturesSagas from '@/containers/DevToolsNew/BetaFeatures/betaFeaturesSagas'
import nettingUpdaterSagas from '@/containers/OrganizationsManagement/NettingUpdater/nettingUpdaterSagas'
import organizationsManagementSagas from '@/containers/OrganizationsManagement/organizationsManagementSagas'
import offerCutPeriodsSagas from '@/containers/OrganizationsManagement/OfferForm/AvailabilityTab/offerCutPeriodsSagas'
import dashboardV2Sagas from '@/containers/DashboardPageV2/DashboardV2Sagas'
import homeSagas from '@/containers/HomePage/HomeSagas'
import hopTimusSagas from '@/hoc/HopTimusButton/hopTimusSagas'

export default function* rootSaga() {
  yield all([
    fork(authSagas),
    fork(pageConfigurationSagas),
    fork(usersManagementSagas),
    fork(servicesStatusSagas),
    fork(carbonOffsetsSagas),
    fork(officesManagementSagas),
    fork(teamsManagementSagas),
    fork(suppliersManagementSagas),
    fork(italyFiscalCodesManagementSagas),
    fork(websalesUsersManagementSagas),
    fork(assistanceSagas),
    fork(monConseillerPersoSagas),
    fork(subscriptionFormV2Sagas),
    fork(searchContactsSagas),
    fork(clientCallbacksSagas),
    fork(breakManagementSagas),
    fork(additionalProductsToolsSagas),
    fork(contactsToolsSagas),
    fork(podUpdaterSagas),
    fork(commandsSagas),
    fork(communicationBoardSagas),
    fork(pollResultsSagas),
    fork(boardPollsSagas),
    fork(cacheSagas),
    fork(betaFeaturesSagas),
    fork(nettingUpdaterSagas),
    fork(organizationsManagementSagas),
    fork(offerCutPeriodsSagas),
    fork(dashboardV2Sagas),
    fork(homeSagas),
    fork(hopTimusSagas),
  ])
}
